import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TabsModule } from 'primeng/tabs';
import { CarouselModule } from 'primeng/carousel';
import { DrawerModule } from 'primeng/drawer';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { FloatLabelModule } from 'primeng/floatlabel';
import { MessageModule } from 'primeng/message';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputOtpModule } from 'primeng/inputotp';
import { ContextMenuModule } from 'primeng/contextmenu';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { IftaLabelModule } from 'primeng/iftalabel';
import { OverlayModule } from 'primeng/overlay';
import { ToastModule } from 'primeng/toast';
import { DragDropModule } from 'primeng/dragdrop';
import { PopoverModule } from 'primeng/popover';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { MeterGroupModule } from 'primeng/metergroup';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { EditorModule } from 'primeng/editor';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { DatePickerModule } from 'primeng/datepicker';

const PRIMENG_MODULES = [
  ButtonModule,
  CardModule,
  TabsModule,
  CarouselModule,
  DrawerModule,
  SelectModule,
  MultiSelectModule,
  ContextMenuModule,
  TextareaModule,
  InputTextModule,
  PasswordModule,
  FloatLabelModule,
  MessageModule,
  KeyFilterModule,
  InputNumberModule,
  InputMaskModule,
  AutoCompleteModule,
  InputGroupModule,
  InputGroupAddonModule,
  InputOtpModule,
  CascadeSelectModule,
  IftaLabelModule,
  OverlayModule,
  ToastModule,
  DragDropModule,
  PopoverModule,
  BadgeModule,
  OverlayBadgeModule,
  MeterGroupModule,
  BreadcrumbModule,
  EditorModule,
  ChipModule,
  TooltipModule,
  DatePickerModule,
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...PRIMENG_MODULES,
  ],
  exports: [CommonModule, ...PRIMENG_MODULES],
})
export class PrimengModule {
}
